import { Controller } from "@hotwired/stimulus";
import Chart from 'chart.js/auto';
import ChartDataLabels from "chartjs-plugin-datalabels";

export default class BarChartController extends Controller {
    connect() {
        let labels = JSON.parse(this.element.dataset.labels);
        let chartData = JSON.parse(this.element.dataset.chartData);
        let chartType = this.element.dataset.chartType || "bar";
        let chatLabel = this.element.dataset.label || "";
        let backgroundColor = this.element.dataset.bg;

        this.chart = new Chart(
            this.element,
            {
                type: chartType,
                plugins: [ChartDataLabels],
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: chatLabel,
                            data: chartData,
                            backgroundColor: backgroundColor
                        }
                    ]
                }
            }
        );
    }
}
